import React from 'react';
import { observer } from 'mobx-react';
import { WeaDatePicker } from 'ecCom';

interface Props {
    editable?: boolean;
    value?: string;
    valueSpan?: string;
    viewAttr:string;
    onChange: (string) => void;
}

export default observer((props: Props) => {
    const {value,onChange,viewAttr } = props;
    return (
        <div style={{float:'left'}}>
            <WeaDatePicker noInput
                value={value}
                viewAttr={viewAttr}
                onChange={onChange}
            />
        </div>
    )
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/WeaDatePicker.tsx